import './FeedGenderFilter.sass';

import React, { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button, SegmentedControl } from '$uikit';
import { useTranslator } from '$hooks';
import { GenderFilterEnum } from '$store/models';
import { profileActions } from '$store/profile';

export const FeedGenderFilter: FC = () => {
  const t = useTranslator();
  const [value, setValue] = useState(GenderFilterEnum.WOMEN);
  const dispatch = useDispatch();
  const handleSave = useCallback(() => {
    dispatch(
      profileActions.changeGenderPriority({
        genderFilter: value,
        needReloadFeed: value !== GenderFilterEnum.WOMEN,
      }),
    );
  }, [dispatch, value]);

  return (
    <div className="FeedGenderFilter">
      <div className="FeedGenderFilter__title">{t('gender_filter_feed_title')}</div>
      <SegmentedControl
        mode="alternative"
        options={[
          {
            label: t('gender_filter_feed_option_women'),
            value: GenderFilterEnum.WOMEN,
          },
          {
            label: t('gender_filter_feed_option_men'),
            value: GenderFilterEnum.MEN,
          },
          {
            label: t('gender_filter_feed_option_both'),
            value: GenderFilterEnum.BOTH,
          },
        ]}
        defaultValue={value}
        onChange={setValue}
      />
      <div className="FeedGenderFilter__action">
        <Button stretched onClick={handleSave}>
          {t('gender_filter_feed_save')}
        </Button>
      </div>
    </div>
  );
};
